var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPreview2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24935 9.83301L11.7285 7.54134C11.9507 7.40245 12.0618 7.20801 12.0618 6.95801C12.0618 6.70801 11.9507 6.51356 11.7285 6.37467L8.24935 4.08301C8.01324 3.93023 7.77365 3.91981 7.5306 4.05176C7.28754 4.1837 7.16602 4.39551 7.16602 4.68718V9.22884C7.16602 9.52051 7.28754 9.73231 7.5306 9.86426C7.77365 9.9962 8.01324 9.98579 8.24935 9.83301ZM1.95768 13.7913C1.58268 13.7913 1.25282 13.649 0.968099 13.3643C0.683377 13.0795 0.541016 12.7497 0.541016 12.3747V1.62467C0.541016 1.23579 0.683377 0.902452 0.968099 0.624674C1.25282 0.346897 1.58268 0.208008 1.95768 0.208008H16.041C16.4299 0.208008 16.7632 0.346897 17.041 0.624674C17.3188 0.902452 17.4577 1.23579 17.4577 1.62467V12.3747C17.4577 12.7497 17.3188 13.0795 17.041 13.3643C16.7632 13.649 16.4299 13.7913 16.041 13.7913H1.95768ZM1.95768 12.3747V1.62467V12.3747ZM1.95768 12.3747H16.041V1.62467H1.95768V12.3747Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPreview2);
export default __webpack_public_path__ + "static/media/video-preview2.70eb8c8d.svg";
export { ForwardRef as ReactComponent };